import { render, staticRenderFns } from "./personalAreaTemplate.vue?vue&type=template&id=15049d4e&scoped=true&"
import script from "./personalAreaTemplate.vue?vue&type=script&lang=js&"
export * from "./personalAreaTemplate.vue?vue&type=script&lang=js&"
import style0 from "./personalAreaTemplate.vue?vue&type=style&index=0&id=15049d4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15049d4e",
  null
  
)

export default component.exports